import { Client, mapUrl } from "../client";
import { Controller } from "../controller";
import { Endpoint } from "../endpoint";
import { QueueStatistics, QueueStatisticsRequest } from "../models/statistics";

export const fetchQueueStatistics = async (
	queueStatisticsRequest: QueueStatisticsRequest
): Promise<QueueStatistics[]> => {
	const url = mapUrl(Controller.History, Endpoint.QueueStatistics);

	return Client.instance.post<QueueStatistics[]>(url, queueStatisticsRequest);
};
